import { SVGProps } from 'react';

const OrderPlacementRightArrow = ({ className }: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      className={className}
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="OrderPlacementRightArrow">
      <path
        d="M3.87951 4.99988L0.166992 1.28732L1.2275 0.226809L6.00052 4.99988L1.2275 9.77295L0.166992 8.71243L3.87951 4.99988Z"
        fill="var(--brand-bg-primary)"
      />
    </svg>)
  );
};

export default OrderPlacementRightArrow;
